import {
  RadarModule,
  createRadarServices
} from "./chunks/mermaid-parser.core/chunk-VTWWFHGB.mjs";
import {
  RailroadModule,
  createRailroadServices
} from "./chunks/mermaid-parser.core/chunk-ZO67DCNQ.mjs";
import {
  RailroadEbnfModule,
  createRailroadEbnfServices
} from "./chunks/mermaid-parser.core/chunk-F6S3BTY2.mjs";
import {
  RailroadAbnfModule,
  createRailroadAbnfServices
} from "./chunks/mermaid-parser.core/chunk-YK26KJH5.mjs";
import {
  RailroadPegModule,
  createRailroadPegServices
} from "./chunks/mermaid-parser.core/chunk-BP2KR52E.mjs";
import {
  TreemapModule,
  createTreemapServices
} from "./chunks/mermaid-parser.core/chunk-4S7OKTRW.mjs";
import {
  WardleyModule,
  createWardleyServices
} from "./chunks/mermaid-parser.core/chunk-53FOQ5SW.mjs";
import {
  CynefinModule,
  createCynefinServices
} from "./chunks/mermaid-parser.core/chunk-VPELOWWC.mjs";
import {
  GitGraphModule,
  createGitGraphServices
} from "./chunks/mermaid-parser.core/chunk-VZTHESGH.mjs";
import {
  InfoModule,
  createInfoServices
} from "./chunks/mermaid-parser.core/chunk-3M4EKCLJ.mjs";
import {
  PacketModule,
  createPacketServices
} from "./chunks/mermaid-parser.core/chunk-OD3NTWWA.mjs";
import {
  PieModule,
  createPieServices
} from "./chunks/mermaid-parser.core/chunk-QNH66VMT.mjs";
import {
  TreeViewModule,
  createTreeViewServices
} from "./chunks/mermaid-parser.core/chunk-KPI5JJXK.mjs";
import {
  ArchitectureModule,
  createArchitectureServices
} from "./chunks/mermaid-parser.core/chunk-24IY7LWP.mjs";
import {
  EventModelingModule,
  createEventModelingServices
} from "./chunks/mermaid-parser.core/chunk-TPMEZKFX.mjs";
import {
  AbnfAlternation,
  AbnfConcatenation,
  AbnfElement,
  AbnfGroup,
  AbnfNumVal,
  AbnfOptionalGroup,
  AbnfPrimary,
  AbnfRule,
  AbnfRuleName,
  AbnfStringLiteral,
  AbstractMermaidTokenBuilder,
  AbstractMermaidValueConverter,
  Architecture,
  ArchitectureGrammarGeneratedModule,
  Branch,
  Commit,
  CommonTokenBuilder,
  CommonValueConverter,
  Cynefin,
  CynefinGrammarGeneratedModule,
  DomainBlock,
  DomainItem,
  EbnfChoice,
  EbnfExceptionPostfix,
  EbnfGroup,
  EbnfNonTerminal,
  EbnfOneOrMorePostfix,
  EbnfOptional,
  EbnfOptionalPostfix,
  EbnfPostfix,
  EbnfPrimary,
  EbnfRepetition,
  EbnfRule,
  EbnfSequence,
  EbnfSpecial,
  EbnfTerm,
  EbnfTerminal,
  EbnfZeroOrMorePostfix,
  EmDataEntity,
  EmFrame,
  EventModel,
  EventModelingGeneratedModule,
  GitGraph,
  GitGraphGrammarGeneratedModule,
  Info,
  InfoGrammarGeneratedModule,
  Merge,
  MermaidGeneratedSharedModule,
  Packet,
  PacketBlock,
  PacketGrammarGeneratedModule,
  PegAny,
  PegGroup,
  PegIdentifier,
  PegLiteral,
  PegOrderedChoice,
  PegPrefix,
  PegPrimary,
  PegRule,
  PegSequence,
  PegSuffix,
  Pie,
  PieGrammarGeneratedModule,
  PieSection,
  Radar,
  RadarGrammarGeneratedModule,
  Railroad,
  RailroadAbnf,
  RailroadAbnfGrammarGeneratedModule,
  RailroadChoiceExpr,
  RailroadEbnf,
  RailroadEbnfGrammarGeneratedModule,
  RailroadExpression,
  RailroadGrammarGeneratedModule,
  RailroadNonTerminalExpr,
  RailroadOneOrMoreExpr,
  RailroadOptionalExpr,
  RailroadPeg,
  RailroadPegGrammarGeneratedModule,
  RailroadRule,
  RailroadSequenceExpr,
  RailroadSpecialExpr,
  RailroadTerminalExpr,
  RailroadZeroOrMoreExpr,
  Statement,
  Transition,
  TreeNode,
  TreeView,
  TreeViewGrammarGeneratedModule,
  Treemap,
  TreemapGrammarGeneratedModule,
  Wardley,
  WardleyGrammarGeneratedModule,
  __name,
  isArchitecture,
  isBranch,
  isCommit,
  isCynefin,
  isDomainBlock,
  isDomainItem,
  isEmModelEntityType,
  isEmResetFrame,
  isGitGraph,
  isInfo,
  isMerge,
  isPacket,
  isPacketBlock,
  isPie,
  isPieSection,
  isRailroad,
  isRailroadAbnf,
  isRailroadEbnf,
  isRailroadPeg,
  isTransition,
  isTreemap,
  isWardley
} from "./chunks/mermaid-parser.core/chunk-NGNAAXSQ.mjs";

// src/parse.ts
var parsers = {};
var initializers = {
  info: /* @__PURE__ */ __name(async () => {
    const { createInfoServices: createInfoServices2 } = await import("./chunks/mermaid-parser.core/info-OHQRW6UA.mjs");
    const parser = createInfoServices2().Info.parser.LangiumParser;
    parsers.info = parser;
  }, "info"),
  packet: /* @__PURE__ */ __name(async () => {
    const { createPacketServices: createPacketServices2 } = await import("./chunks/mermaid-parser.core/packet-JDAUHWVQ.mjs");
    const parser = createPacketServices2().Packet.parser.LangiumParser;
    parsers.packet = parser;
  }, "packet"),
  pie: /* @__PURE__ */ __name(async () => {
    const { createPieServices: createPieServices2 } = await import("./chunks/mermaid-parser.core/pie-XZMESJXO.mjs");
    const parser = createPieServices2().Pie.parser.LangiumParser;
    parsers.pie = parser;
  }, "pie"),
  treeView: /* @__PURE__ */ __name(async () => {
    const { createTreeViewServices: createTreeViewServices2 } = await import("./chunks/mermaid-parser.core/treeView-D4JQ5SDB.mjs");
    const parser = createTreeViewServices2().TreeView.parser.LangiumParser;
    parsers.treeView = parser;
  }, "treeView"),
  architecture: /* @__PURE__ */ __name(async () => {
    const { createArchitectureServices: createArchitectureServices2 } = await import("./chunks/mermaid-parser.core/architecture-WOLXFQ4H.mjs");
    const parser = createArchitectureServices2().Architecture.parser.LangiumParser;
    parsers.architecture = parser;
  }, "architecture"),
  gitGraph: /* @__PURE__ */ __name(async () => {
    const { createGitGraphServices: createGitGraphServices2 } = await import("./chunks/mermaid-parser.core/gitGraph-VSP46ZUC.mjs");
    const parser = createGitGraphServices2().GitGraph.parser.LangiumParser;
    parsers.gitGraph = parser;
  }, "gitGraph"),
  eventmodeling: /* @__PURE__ */ __name(async () => {
    const { createEventModelingServices: createEventModelingServices2 } = await import("./chunks/mermaid-parser.core/eventmodeling-K75KTNOO.mjs");
    const parser = createEventModelingServices2().EventModel.parser.LangiumParser;
    parsers.eventmodeling = parser;
  }, "eventmodeling"),
  radar: /* @__PURE__ */ __name(async () => {
    const { createRadarServices: createRadarServices2 } = await import("./chunks/mermaid-parser.core/radar-ABXABTNO.mjs");
    const parser = createRadarServices2().Radar.parser.LangiumParser;
    parsers.radar = parser;
  }, "radar"),
  railroad: /* @__PURE__ */ __name(async () => {
    const { createRailroadServices: createRailroadServices2 } = await import("./chunks/mermaid-parser.core/railroad-I3PHUGI6.mjs");
    const parser = createRailroadServices2().Railroad.parser.LangiumParser;
    parsers.railroad = parser;
  }, "railroad"),
  railroadEbnf: /* @__PURE__ */ __name(async () => {
    const { createRailroadEbnfServices: createRailroadEbnfServices2 } = await import("./chunks/mermaid-parser.core/railroad-ebnf-DWYD2UWJ.mjs");
    const parser = createRailroadEbnfServices2().RailroadEbnf.parser.LangiumParser;
    parsers.railroadEbnf = parser;
  }, "railroadEbnf"),
  railroadAbnf: /* @__PURE__ */ __name(async () => {
    const { createRailroadAbnfServices: createRailroadAbnfServices2 } = await import("./chunks/mermaid-parser.core/railroad-abnf-LNEFI6M7.mjs");
    const parser = createRailroadAbnfServices2().RailroadAbnf.parser.LangiumParser;
    parsers.railroadAbnf = parser;
  }, "railroadAbnf"),
  railroadPeg: /* @__PURE__ */ __name(async () => {
    const { createRailroadPegServices: createRailroadPegServices2 } = await import("./chunks/mermaid-parser.core/railroad-peg-JR7BVNR7.mjs");
    const parser = createRailroadPegServices2().RailroadPeg.parser.LangiumParser;
    parsers.railroadPeg = parser;
  }, "railroadPeg"),
  treemap: /* @__PURE__ */ __name(async () => {
    const { createTreemapServices: createTreemapServices2 } = await import("./chunks/mermaid-parser.core/treemap-SAJKECNS.mjs");
    const parser = createTreemapServices2().Treemap.parser.LangiumParser;
    parsers.treemap = parser;
  }, "treemap"),
  wardley: /* @__PURE__ */ __name(async () => {
    const { createWardleyServices: createWardleyServices2 } = await import("./chunks/mermaid-parser.core/wardley-7MLQ67FV.mjs");
    const parser = createWardleyServices2().Wardley.parser.LangiumParser;
    parsers.wardley = parser;
  }, "wardley"),
  cynefin: /* @__PURE__ */ __name(async () => {
    const { createCynefinServices: createCynefinServices2 } = await import("./chunks/mermaid-parser.core/cynefin-EF2NZ3EQ.mjs");
    const parser = createCynefinServices2().Cynefin.parser.LangiumParser;
    parsers.cynefin = parser;
  }, "cynefin")
};
async function parse(diagramType, text) {
  const initializer = initializers[diagramType];
  if (!initializer) {
    throw new Error(`Unknown diagram type: ${diagramType}`);
  }
  if (!parsers[diagramType]) {
    await initializer();
  }
  const parser = parsers[diagramType];
  const result = parser.parse(text);
  if (result.lexerErrors.length > 0 || result.parserErrors.length > 0) {
    throw new MermaidParseError(result);
  }
  return result.value;
}
__name(parse, "parse");
var formatLocation = /* @__PURE__ */ __name((value) => value !== void 0 && value >= 0 ? value : "?", "formatLocation");
var MermaidParseError = class extends Error {
  constructor(result) {
    const lexerErrors = result.lexerErrors.map((err) => {
      const line = formatLocation(err.line);
      const column = formatLocation(err.column);
      return `Lexer error on line ${line}, column ${column}: ${err.message}`;
    }).join("\n");
    const parserErrors = result.parserErrors.map((err) => {
      const line = formatLocation(err.token.startLine);
      const column = formatLocation(err.token.startColumn);
      return `Parse error on line ${line}, column ${column}: ${err.message}`;
    }).join("\n");
    super(`Parsing failed: ${lexerErrors} ${parserErrors}`);
    this.result = result;
  }
  static {
    __name(this, "MermaidParseError");
  }
};
export {
  AbnfAlternation,
  AbnfConcatenation,
  AbnfElement,
  AbnfGroup,
  AbnfNumVal,
  AbnfOptionalGroup,
  AbnfPrimary,
  AbnfRule,
  AbnfRuleName,
  AbnfStringLiteral,
  AbstractMermaidTokenBuilder,
  AbstractMermaidValueConverter,
  Architecture,
  ArchitectureGrammarGeneratedModule as ArchitectureGeneratedModule,
  ArchitectureModule,
  Branch,
  Commit,
  CommonTokenBuilder,
  CommonValueConverter,
  Cynefin,
  CynefinGrammarGeneratedModule as CynefinGeneratedModule,
  CynefinModule,
  DomainBlock,
  DomainItem,
  EbnfChoice,
  EbnfExceptionPostfix,
  EbnfGroup,
  EbnfNonTerminal,
  EbnfOneOrMorePostfix,
  EbnfOptional,
  EbnfOptionalPostfix,
  EbnfPostfix,
  EbnfPrimary,
  EbnfRepetition,
  EbnfRule,
  EbnfSequence,
  EbnfSpecial,
  EbnfTerm,
  EbnfTerminal,
  EbnfZeroOrMorePostfix,
  EmDataEntity,
  EmFrame,
  EventModel,
  EventModelingGeneratedModule,
  EventModelingModule,
  GitGraph,
  GitGraphGrammarGeneratedModule as GitGraphGeneratedModule,
  GitGraphModule,
  Info,
  InfoGrammarGeneratedModule as InfoGeneratedModule,
  InfoModule,
  Merge,
  MermaidGeneratedSharedModule,
  MermaidParseError,
  Packet,
  PacketBlock,
  PacketGrammarGeneratedModule as PacketGeneratedModule,
  PacketModule,
  PegAny,
  PegGroup,
  PegIdentifier,
  PegLiteral,
  PegOrderedChoice,
  PegPrefix,
  PegPrimary,
  PegRule,
  PegSequence,
  PegSuffix,
  Pie,
  PieGrammarGeneratedModule as PieGeneratedModule,
  PieModule,
  PieSection,
  Radar,
  RadarGrammarGeneratedModule as RadarGeneratedModule,
  RadarModule,
  Railroad,
  RailroadAbnf,
  RailroadAbnfGrammarGeneratedModule as RailroadAbnfGeneratedModule,
  RailroadAbnfModule,
  RailroadChoiceExpr,
  RailroadEbnf,
  RailroadEbnfGrammarGeneratedModule as RailroadEbnfGeneratedModule,
  RailroadEbnfModule,
  RailroadExpression,
  RailroadGrammarGeneratedModule as RailroadGeneratedModule,
  RailroadModule,
  RailroadNonTerminalExpr,
  RailroadOneOrMoreExpr,
  RailroadOptionalExpr,
  RailroadPeg,
  RailroadPegGrammarGeneratedModule as RailroadPegGeneratedModule,
  RailroadPegModule,
  RailroadRule,
  RailroadSequenceExpr,
  RailroadSpecialExpr,
  RailroadTerminalExpr,
  RailroadZeroOrMoreExpr,
  Statement,
  Transition,
  TreeNode,
  TreeView,
  TreeViewGrammarGeneratedModule as TreeViewGeneratedModule,
  TreeViewModule,
  Treemap,
  TreemapGrammarGeneratedModule as TreemapGeneratedModule,
  TreemapModule,
  Wardley,
  WardleyGrammarGeneratedModule as WardleyGeneratedModule,
  WardleyModule,
  createArchitectureServices,
  createCynefinServices,
  createEventModelingServices,
  createGitGraphServices,
  createInfoServices,
  createPacketServices,
  createPieServices,
  createRadarServices,
  createRailroadAbnfServices,
  createRailroadEbnfServices,
  createRailroadPegServices,
  createRailroadServices,
  createTreeViewServices,
  createTreemapServices,
  createWardleyServices,
  isArchitecture,
  isBranch,
  isCommit,
  isCynefin,
  isDomainBlock,
  isDomainItem,
  isEmModelEntityType,
  isEmResetFrame,
  isGitGraph,
  isInfo,
  isMerge,
  isPacket,
  isPacketBlock,
  isPie,
  isPieSection,
  isRailroad,
  isRailroadAbnf,
  isRailroadEbnf,
  isRailroadPeg,
  isTransition,
  isTreemap,
  isWardley,
  parse
};
